import { queryAllPages } from '../../apollo/query-all-pages';
import { gql } from "@apollo/client";
import { client } from "../../apollo/client";

const SHIPPERS_REQUESTS = gql`
  query GetShippers {
    shippers(limit: 1000, offset: 0) {
      data {
        codigo
        master
        status
        dataCadastro
        nome
      }
      totalRecords
    }
  }
`;

export const getAllShippers = async () => {
    
        const response = await queryAllPages(client, {
            query: SHIPPERS_REQUESTS,
            // variables: {
            //   input: bar
            // }
        });
        const { data } = response.data.shippers;
        return data;
    
}
